import { z } from '@/libs/zod';

/**
 * @deprecated Use `WhitelabelConfigResponse` from `@/types/models/WhitelabelConfig`.
 * SystemParameters é o sistema legado e será removido em breve.
 */
export const systemParametersSchema = z.object({
  id: z.string(),
  key: z.string(),
  value: z.string(),
  updatedAt: z
    .union([z.string(), z.date()])
    .transform((date) => (typeof date === 'string' ? new Date(date) : date)),
});

export type SystemParameters = z.infer<typeof systemParametersSchema>;
